import moment from 'moment';
import { FC, useMemo } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../shared/appointment-ended-message/appointment-ended-message';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { RunVerificationButton } from '../shared/run-verification-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const VerificationInProcessStatusDialog: FC = () => {
  const { opened, onClose, isLoading, selectedIvSummary, patientInfo, appointment } = usePatientIvStatusDialog();
  const isLongRunningVerification = useMemo(
    () => moment.utc().diff(moment.utc(selectedIvSummary?.dateSubmitted), 'days') > 1,
    [selectedIvSummary]
  );

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Verification In Process"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateSubmitted && (
            <>&nbsp;- Started {moment.utc(selectedIvSummary.dateSubmitted).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '30px 0 20px 0', display: 'block' }}>
        We're currently in the process of verifying this patient's insurance. This verification may take up to two (2)
        hours to complete.
      </DialogSubTitle>
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        {isLongRunningVerification && !appointment?.isEnded && (
          <RunVerificationButton label="Re-run Verification" onSuccess={async () => onClose()} disabled={isLoading} />
        )}
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(VerificationInProcessStatusDialog);
